<template>
  <v-row>
    <v-col cols="12" class="mb-5">
      <v-stepper v-model="e2" class="transparent elevation-0">
        <v-card class="mb-5">
          <v-stepper-header class="autoheight">
            <v-stepper-step @click="setStepRelations(1)" :complete="e2 > 1" step="1">{{ languageData.projects }}</v-stepper-step>
            <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
            <v-stepper-step @click="setStepRelations(2)" :complete="e2 > 2" step="2">{{ languageData.invoices }}</v-stepper-step>
          </v-stepper-header>
        </v-card>
        <v-card>
          <v-stepper-items>
            <v-stepper-content step="1">
              <ProjectsRelation></ProjectsRelation>
            </v-stepper-content>
            <v-stepper-content step="2">
              <Invoices :modelType="'client'"></Invoices>
            </v-stepper-content>
          </v-stepper-items>
        </v-card>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script type="text/javascript">
  import ProjectsRelation from "./Projects/Projects";
  import Invoices from "../../../Invoices/components/Invoices/Invoices";

  export default {
    name: "ClientsRelations",
    data() {
      return {
        e2: 1
      }
    },
    components: {
      ProjectsRelation,
      Invoices
    },
    methods: {
      setStepRelations: function(step) {
        this.e2 = step;
      }
    }
  }
</script>